<script>
import pagination from '@/mixins/pagination';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import reduce from 'lodash/reduce';
import {mapActions, mapMutations, mapState, mapGetters} from 'vuex';
import ElDialog from '../Dialog';
import TrekButton from '@/components/TrekButton';
import Collapse from '@/components/Collapse';
import CollapseItem from '@/components/CollapseItem';
import Tabs from '@/components/tabs/Tabs';
import TabPane from '@/components/tabs/TabPane';
import CartProductGrid from '@/components/cart/CartProductGrid';
import SavedListsPanel from '@/components/saved-lists/SavedListsPanel';
import AppleLabelGrid from '@/components/checkout/AppleLabelGrid';
import Pagination from '@/components/Pagination.vue';
import Swatch from '@/components/Swatch';

export default {
  components: {
    TrekButton,
    Pagination,
    ElDialog,
    Collapse,
    CollapseItem,
    Tabs,
    TabPane,
    CartProductGrid,
    SavedListsPanel,
    AppleLabelGrid,
    Swatch,
  },
  mixins: [pagination],

  props: {
    cartId: {
      type: String,
      default: '',
    },
    listData: {
      type: Array,
      default: () => [],
    },
    partTypeKey: {
      type: String,
      default: '',
    },
    itemIdKey: {
      type: String,
      default: '',
    },
    cartSummary: {
      type: Object,
      default: () => {},
    },
    size: {
      type: Number,
      required: false,
      default: ACC.cartItemsPageSize || 15,
    },
  },

  data() {
    return {
      isDialogVisible: false,
    };
  },

  computed: {
    isDisabled() {
      return (
        (this.partTypeKey === 'bikes' && this.selectedProductsBikeCount === 0) ||
        (this.partTypeKey !== 'bikes' && this.selectedProductsAccessoriesCount === 0) ||
        false
      );
    },
    collapseRef() {
      return `collapse-${this.partTypeKey}`;
    },

    ...mapState('backend', ['cartToggle', 'appleLabelAccess']),
    ...mapGetters('backend', ['consumerFriendlyMode']),
    ...mapGetters('cart', ['selectedProductsBikeCount', 'selectedProductsAccessoriesCount', 'selectedProducts']),
  },
  methods: {
    resetDeleteData() {
      this.isDialogVisible = false;
    },
    confirmDelete() {
      this.deleteSelectedProducts(this.partTypeKey);
      this.isDialogVisible = false;
    },
    // TODO: Refactor this to use the same function as BulkProductGrid and share between the two
    getAppleLabelData(item) {
      if (!this.displayAppleLabels) return [];

      return item.entries.map((entry) => {
        return {
          id: entry.sku,
          sku: entry.sku,
          retailLabelStatus: entry.appleLabels.retailLabelStatus,
          retailLabelDescription: entry.appleLabels.retailLabelDescription,
          retailLabelProductId: entry.appleLabels.retailLabelProductId,
          retailLabelPrice: entry.appleLabels.retailLabelPrice,
          msrp: entry.price.msrp,
        };
      });
    },

    updateSavedList() {
      if (this.partTypeKey === 'bikes') {
        this.setEntries(this.selectedProducts.filter((product) => product.productType === 'bike'));
      } else {
        this.setEntries(this.selectedProducts.filter((product) => product.productType !== 'bike'));
      }
    },

    getProductQuantity(product) {
      return reduce(product.warehouses, (result, warehouse) => result + parseInt(warehouse.orderedQty), 0);
    },

    onTabClick(tab) {
      this.$emit('tab-selected', tab.name);
    },

    displayAppleLabels(partTypeKey) {
      return this.appleLabelAccess[partTypeKey] && !isEmpty(this.listData[0].entries[0].appleLabels);
    },

    getPartKeyQAID(name) {
      return `cart.${this.partTypeKey}.tab.${name}`;
    },

    getGroupDisplayImage(product) {
      let imageSuffix =
        '?wid=160&amp;hei=120&amp;fmt=png8-alpha&amp;qlt=80,1&amp;op_usm=0,0,0,0&amp;iccEmbed=0&amp;cache=on,on';

      let image = get(product, 'entries[0].variantImage');

      return image ? ACC.scene7ProductImageUrl + image + imageSuffix : null;
    },

    getGroupDisplayColor(product) {
      return get(product, 'entries[0].variantValueCategories[0].Color.code');
    },

    getGroupDisplayColorName(product) {
      return get(product, 'entries[0].variantValueCategories[0].Color.name');
    },

    getGroupingVariant(product) {
      const variantValueCategory = get(product, 'entries[0].variantValueCategories[0]');
      return variantValueCategory ? variantValueCategory[product.groupBy] : null;
    },

    getCollapseItemName(partTypeKey, itemIdKey, index) {
      return `${partTypeKey}-${itemIdKey}-${index}`;
    },

    updatePage(page) {
      if (page !== this.pageNumber) {
        this.pageNumber = page;
      }

      this.$nextTick(() => {
        if (this.$refs[this.collapseRef] !== null) {
          this.$refs[this.collapseRef][0].setAllActive();
        }
      });
    },

    ...mapMutations('savedLists', ['setEntries']),

    ...mapActions('cart', [
      'removeProducts',
      'undoRemove',
      'clearSelectedProducts',
      'updateCart',
      'deleteSelectedProducts',
    ]),
  },
};
</script>
